export const SETTING_COPY = {
  calendarPermissionLevel: {
    label: "Read Assistant will join",
    tooltip:
      "Read Assistant can automatically join your meetings, record, and generate meeting notes for your connected calendar.",
  },
  calendarOnlyJoinInternal: {
    label: "Where participants are",
    tooltip:
      "Internal participants are people in your organization (same domain), while external participants are outside of your organization.",
  },
  internalParticipantAccessLevel: {
    label: "Internal Participants",
    tooltip:
      "Choose whether meeting participants inside of your organization automatically get editor, viewer, or no access to meeting notes.",
  },
  externalParticipantAccessLevel: {
    label: "External Participants",
    tooltip:
      "Choose whether meeting participants outside of your organization automatically get editor, viewer, or no access to meeting notes.",
  },
  emailMeetingRecaps: {
    label: "Email meeting recaps to",
    tooltip:
      "Meeting recaps include a summary of the meeting, topics, action items, key questions, transcript, highlights, and participant talk time. They may also include audio and video playback (depending on your plan).",
  },
  emailMeetingPreReads: {
    label: "Email Pre-Reads to",
    tooltip:
      "Pre-Reads can be sent before a recurring meeting with a recap of the previous meeting. It can only be sent to people with access to the previous report who are also invited to the upcoming meeting.",
  },
};
